/**
 * Filtro de operador en Líneas — misma lógica que Mobile (all-routes).
 * El filtrado es client-side; no hay endpoint de "filtro por operador".
 */

import { APP_CODE } from 'js/lib/constants'

export function shouldShowOperatorFilter(appCode, operators) {
  const code = String(appCode || '').toLowerCase()
  const list = Array.isArray(operators) ? operators : []
  // Misma exclusión que Mobile Líneas (COEGIS1-10779); no reutilizar
  // planner capabilities (ahí GC y MR ocultan el filtro).
  return code !== APP_CODE.GC && list.length > 1
}

export function selectedOperatorIds(operators) {
  return (Array.isArray(operators) ? operators : [])
    .filter(operator => operator && operator.selected)
    .map(operator => String(operator.id))
}

/**
 * @param {Array<Object>} sublines
 * @param {Array<Object>} operators
 * @param {boolean} showFilter - si false (APP_CODE.GC / 1 op), no filtra
 * @returns {Array<Object>} sublíneas visibles
 */
export function filterSublinesBySelectedOperators(sublines, operators, showFilter) {
  const list = Array.isArray(sublines) ? sublines : []
  if (!showFilter) return list

  const ids = selectedOperatorIds(operators)
  return list.filter(item =>
    Array.isArray(item.operator_ids) &&
    item.operator_ids.some(operatorId => ids.includes(String(operatorId)))
  )
}
